export function validEGPassword(password) {
  const regex = /^(?=.*[A-Z])(?=.*[!@#$%^&*()_+|~\-=`{}\[\]:";'<>,.?/\\]).{12,}$/;
  return regex.test(password);
}